(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["difficult-banner-announcement"] && !Shopify.designMode) return;
  try {
    
  class HsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hsa-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hsa-dot]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.timer = null;

      const prev = this.querySelector('.hsa__arrow--prev');
      const next = this.querySelector('.hsa__arrow--next');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, -1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1, 1); this.restart(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i, i > this.index ? 1 : -1);
          this.restart();
        });
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      // Se pausa cuando la pestana no esta visible: ahorra bateria
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(target, direction) {
      const total = this.slides.length;
      const nextIndex = (target + total) % total;
      if (nextIndex === this.index) return;

      this.style.setProperty('--hsa-dir', direction);

      const current = this.slides[this.index];
      const incoming = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      incoming.classList.add('is-active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--hsa-dur'), 10) || 400;
      setTimeout(() => current.classList.remove('is-leaving'), duration);

      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === nextIndex));
      this.index = nextIndex;
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1, 1), this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  if (!customElements.get('hs-announcement')) customElements.define('hs-announcement', HsAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-announcement"] && !Shopify.designMode) return;
  try {
    
  class HsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hsa-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hsa-dot]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.timer = null;

      const prev = this.querySelector('.hsa__arrow--prev');
      const next = this.querySelector('.hsa__arrow--next');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, -1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1, 1); this.restart(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i, i > this.index ? 1 : -1);
          this.restart();
        });
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      // Se pausa cuando la pestana no esta visible: ahorra bateria
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(target, direction) {
      const total = this.slides.length;
      const nextIndex = (target + total) % total;
      if (nextIndex === this.index) return;

      this.style.setProperty('--hsa-dir', direction);

      const current = this.slides[this.index];
      const incoming = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      incoming.classList.add('is-active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--hsa-dur'), 10) || 400;
      setTimeout(() => current.classList.remove('is-leaving'), duration);

      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === nextIndex));
      this.index = nextIndex;
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1, 1), this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  if (!customElements.get('hs-announcement')) customElements.define('hs-announcement', HsAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hb-announcementbanner"] && !Shopify.designMode) return;
  try {
    
  class HsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hsa-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hsa-dot]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.timer = null;

      const prev = this.querySelector('.hsa__arrow--prev');
      const next = this.querySelector('.hsa__arrow--next');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, -1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1, 1); this.restart(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i, i > this.index ? 1 : -1);
          this.restart();
        });
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      // Se pausa cuando la pestana no esta visible: ahorra bateria
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(target, direction) {
      const total = this.slides.length;
      const nextIndex = (target + total) % total;
      if (nextIndex === this.index) return;

      this.style.setProperty('--hsa-dir', direction);

      const current = this.slides[this.index];
      const incoming = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      incoming.classList.add('is-active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--hsa-dur'), 10) || 400;
      setTimeout(() => current.classList.remove('is-leaving'), duration);

      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === nextIndex));
      this.index = nextIndex;
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1, 1), this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  if (!customElements.get('hs-announcement')) customElements.define('hs-announcement', HsAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const HS_HOVER_OPEN_DELAY = 120;
  const HS_HOVER_CLOSE_DELAY = 200;

  class HsDrawer extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.hs-drawer__toggle');
      this.panel = this.querySelector('.hs-drawer__panel');
      this.overlay = this.querySelector('.hs-drawer__overlay');
      this.closeBtn = this.querySelector('.hs-drawer__close');
      if (!this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });

      this.querySelectorAll('.hs-drawer__rowbtn').forEach((btn) => {
        btn.addEventListener('click', () => {
          const body = document.getElementById(btn.getAttribute('aria-controls'));
          if (!body) return;
          const isOpen = btn.getAttribute('aria-expanded') === 'true';

          // Solo un acordeon abierto a la vez
          this.querySelectorAll('.hs-drawer__rowbtn').forEach((other) => {
            if (other === btn) return;
            other.setAttribute('aria-expanded', 'false');
            const ob = document.getElementById(other.getAttribute('aria-controls'));
            if (ob) ob.hidden = true;
          });

          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          body.hidden = isOpen;
        });
      });
    }

    open() {
      this.panel.hidden = false;
      if (this.overlay) this.overlay.hidden = false;
      void this.panel.offsetWidth; // fuerza reflow para que la transicion corra
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('hs-drawer-locked');
    }

    close() {
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('hs-drawer-locked');
      setTimeout(() => {
        this.panel.hidden = true;
        if (this.overlay) this.overlay.hidden = true;
      }, 400);
    }
  }
  if (!customElements.get('hs-drawer')) customElements.define('hs-drawer', HsDrawer);

  class HsMegaMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.hs-nav__link');
      this.panel = this.querySelector('.hs-mega__panel');
      if (!this.trigger || !this.panel) return;

      this.openTimer = null;
      this.closeTimer = null;
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      if (this.canHover) {
        this.addEventListener('mouseenter', () => this.scheduleOpen());
        this.addEventListener('mouseleave', () => this.scheduleClose());
        this.panel.addEventListener('mouseenter', () => { clearTimeout(this.closeTimer); });
        this.panel.addEventListener('mouseleave', () => this.scheduleClose());
      }

      this.addEventListener('focusin', () => this.open());
      this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.close(); });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.close(); this.trigger.focus(); }
      });

      this.initTabs();
    }

    scheduleOpen() { clearTimeout(this.closeTimer); this.openTimer = setTimeout(() => this.open(), HS_HOVER_OPEN_DELAY); }
    scheduleClose() { clearTimeout(this.openTimer); this.closeTimer = setTimeout(() => this.close(), HS_HOVER_CLOSE_DELAY); }
    open() { clearTimeout(this.closeTimer); this.classList.add('is-open'); this.trigger.setAttribute('aria-expanded', 'true'); }
    close() {
      clearTimeout(this.openTimer);
      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      if (this.tabs && this.tabs.length) this.activate(this.tabs[0].dataset.hsTab);
    }

    initTabs() {
      this.tabs = this.querySelectorAll('[data-hs-tab]');
      this.panels = this.querySelectorAll('[data-hs-panel]');
      if (!this.tabs.length) return;
      this.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => this.activate(tab.dataset.hsTab));
        tab.addEventListener('focus', () => this.activate(tab.dataset.hsTab));
      });
    }

    activate(index) {
      this.tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.hsTab === index));
      this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.hsPanel === index));
    }
  }
  if (!customElements.get('hs-mega-menu')) customElements.define('hs-mega-menu', HsMegaMenu);

  class HsCurrencySelector extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.querySelector('input[name="country_code"]');
      this.toggle = this.querySelector('.hs-currency__toggle');
      this.panel = this.querySelector('.hs-currency__panel');
      if (!this.form || !this.toggle || !this.panel) return;

      this.toggle.addEventListener('click', () => this.togglePanel());
      this.querySelectorAll('.hs-currency__option').forEach((option) => {
        option.addEventListener('click', () => {
          this.classList.add('is-loading');
          this.input.value = option.dataset.country;
          this.form.submit();
        });
      });

      this.onOutsideClick = (e) => { if (!this.contains(e.target)) this.closePanel(); };
      this.onKeydown = (e) => { if (e.key === 'Escape') { this.closePanel(); this.toggle.focus(); } };
      document.addEventListener('click', this.onOutsideClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutsideClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    togglePanel() { this.panel.hidden ? this.openPanel() : this.closePanel(); }
    openPanel() {
      this.panel.hidden = false;
      this.classList.add('is-open');
      this.toggle.setAttribute('aria-expanded', 'true');
      const current = this.querySelector('[aria-current="true"]');
      if (current) current.scrollIntoView({ block: 'center' });
    }
    closePanel() {
      this.panel.hidden = true;
      this.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }
  if (!customElements.get('hs-currency-selector')) customElements.define('hs-currency-selector', HsCurrencySelector);

  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.header.querySelectorAll('hs-mega-menu').forEach((m) => { if (typeof m.close === 'function') m.close(); });
      this.header.querySelectorAll('hs-currency-selector').forEach((c) => { if (typeof c.closePanel === 'function') c.closePanel(); });
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-divider"] && !Shopify.designMode) return;
  try {
    
  class HsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hsa-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-hsa-dot]'));
      if (this.slides.length < 2) return;

      this.index = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.timer = null;

      const prev = this.querySelector('.hsa__arrow--prev');
      const next = this.querySelector('.hsa__arrow--next');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1, -1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1, 1); this.restart(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.go(i, i > this.index ? 1 : -1);
          this.restart();
        });
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      // Se pausa cuando la pestana no esta visible: ahorra bateria
      document.addEventListener('visibilitychange', () => {
        document.hidden ? this.stop() : this.start();
      });

      this.start();
    }

    disconnectedCallback() { this.stop(); }

    go(target, direction) {
      const total = this.slides.length;
      const nextIndex = (target + total) % total;
      if (nextIndex === this.index) return;

      this.style.setProperty('--hsa-dir', direction);

      const current = this.slides[this.index];
      const incoming = this.slides[nextIndex];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      incoming.classList.add('is-active');

      const duration = parseInt(getComputedStyle(this).getPropertyValue('--hsa-dur'), 10) || 400;
      setTimeout(() => current.classList.remove('is-leaving'), duration);

      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === nextIndex));
      this.index = nextIndex;
    }

    start() {
      if (!this.autoplay || this.timer) return;
      this.timer = setInterval(() => this.go(this.index + 1, 1), this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { this.stop(); this.start(); }
  }

  if (!customElements.get('hs-announcement')) customElements.define('hs-announcement', HsAnnouncement);

  } catch(e) { console.error(e); }
})();
})();
